var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"our-divider-wrapper",class:_vm.dividerWrapperClasses},[_c('div',{staticClass:"our-divider",class:_vm.dividerClasses,attrs:{"data-cy":_vm.dataCy}})])
}
var staticRenderFns = []

export { render, staticRenderFns }